import { forwardRef } from "react";
import { Text as RNText } from "react-native";

import { useTextScaling } from "../../context/TextScaling";
import { useTheme } from "../../utils/theme";
import { useTextProps } from "./useTextProps";

import type { TextVariation } from "@smartrent/tokens";
import type { ReactNode, Ref } from "react";
import type {
  TextProps as RNTextProps,
  StyleProp,
  TextStyle,
} from "react-native";
import type { TestProps } from "../../types";
import type { TextType } from "./types";

export interface TextProps extends RNTextProps, TestProps {
  /**
   * @deprecated please use variation
   */
  type?: TextType;
  variation?: TextVariation;
  style?: StyleProp<TextStyle>;
  children?: ReactNode;
}

export const Text = forwardRef(function Text(
  {
    children,
    style,
    type,
    variation,
    accessibilityRole,
    testID,
    numberOfLines,
    ...rest
  }: TextProps,
  ref: Ref<RNText>
) {
  const { colors } = useTheme();
  const { allowFontScaling, maxFontSizeMultiplier } = useTextScaling();
  const { textStyles, safariStyles, ...props } = useTextProps({
    type,
    variation,
    numberOfLines,
    accessibilityRole,
  });

  return (
    <RNText
      ref={ref}
      testID={testID}
      numberOfLines={numberOfLines}
      allowFontScaling={allowFontScaling}
      maxFontSizeMultiplier={maxFontSizeMultiplier}
      style={[
        safariStyles,
        {
          color: colors.textTitle,
        },
        textStyles,
        style,
      ]}
      {...props}
      {...rest}
    >
      {children}
    </RNText>
  );
});
